<template>
  <ancestryline-modal title="forms.client.card-wedding" :id="'modal-client-wedding-form-'+id" :close="true" @close="close" :loading="false">
    <card :header="$t('forms.client.card-wedding')" class="p-col-12" >
      <coff-input-select v-model="spouseForm.weddingCountry" label="forms.client.weddingCountry" class="p-col-12 p-md-6 p-lg-4" :options="countries" option-value="id" option-label="country" :error="spouseFormValidation.weddingCountry"/>
      <coff-input-select v-model="spouseForm.weddingState" label="forms.client.weddingState" class="p-col-12 p-md-6 p-lg-4" :options="states" :translate="true" option-value="id" v-if="spouseForm.weddingCountry === 'BRASIL'" :error="spouseFormValidation.weddingState"/>
      <coff-input-text v-model="spouseForm.weddingCity" label="forms.client.weddingCity" class="p-col-12 p-md-6 p-lg-4" :error="spouseFormValidation.weddingCity"/>
      <coff-input-auto-complete v-model="spouseForm.selectedSpousePerson" label="forms.client.spouse" class="p-col-10 p-md-6 p-lg-5" :itens="clients" field="name" :func-suggestions="searchClient" :error="spouseFormValidation.selectedSpousePerson"/>
      <div class="text-vertical-center" style="margin-top: 45px;">
          <a class="cursor-pointer p-md-1 " @click.prevent="modalClientSpouseForm('selectedSpousePerson')"><i class="pi pi-users" :title="$t('menu.client.form')"/></a>
      </div>
      <coff-input-date v-model="spouseForm.date" label="forms.client.marriedDay" class="p-col-10 p-md-3 p-lg-3" :error="spouseFormValidation.date" :max-date="new Date()" />
      <coff-input-radio v-model="spouseForm.current" @update="forceUpdateFieldSpouseForm('current', $event)" :options="options" label="forms.client.wedding-current" class="p-col-4 p-md-3 p-lg-3" :error="spouseFormValidation.current" style="max-width: 150px;"/>
      <coff-input-text-editor v-model="spouseForm.observation" label="forms.client.observation" :content_css="content_css" :skin="skin" class="p-col-12 p-md-12 p-lg-12"/>
    </card>    
    <template #footer>
      <div class="p-col-12">
        <Button :label="$t('btn.cancel')" @click.prevent="close" class="p-button-secondary p-mr-auto"/>
        <Button :label="$t('btn.save')" @click.prevent="save" class="float-right p-button-success"/>
      </div>
    </template>
  </ancestryline-modal>
</template>

<script>
import ValidationUtils from "@/utils/ValidationUtils";
import DialogService from "@/business/ModalBusiness";
import ClientBusiness from "@/business/ClientBusiness";
import ModalClientForm from "@/viewer/client/ModalClientForm";
import CountryBusiness from "@/business/CountryBusiness";
import AddressBusiness from "@/business/AddressBusiness";
import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation.vue";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import Utils from "@/utils/Utils";
import store from "@/store";

export default {
  name: "ModalClientWeddingForm",
  props: ["spouseForm", "clientForm"],

  data(){
    return {
      id: Utils.uuid(),
      spouseFormValidation: {
        selectedSpousePerson: false,
        current: false,
        weddingCountry: false,
        weddingState: false,
        weddingCity: false,
      },
      options: [
        {value: true, label: 'field.default.yes'},
        {value: false, label: 'field.default.no'}
      ],
      clients: [],
      states: AddressBusiness.getStates(),
      countries: CountryBusiness.getCountries(),
      content_css: null,
      skin: null,
    }
  },

  methods:{

    async searchClient(name){
      return await ClientBusiness.search(name);
    },

    close(){
      DialogService.closeModal();
    },

    async save(){
      delete this.spouseFormValidation.date;
      delete this.spouseFormValidation.weddingCountry;
      delete this.spouseFormValidation.weddingState;
      delete this.spouseFormValidation.weddingCity;
      this.spouseFormValidation = ValidationUtils.basicValidation(this.spouseFormValidation, this.spouseForm);
      Utils.isEmptyNullOrUndefined(this.spouseForm.date) ? this.spouseFormValidation.date = true : this.spouseFormValidation.date = false;
      Utils.isEmptyNullOrUndefined(this.spouseForm.weddingCountry) ? this.spouseFormValidation.weddingCountry = true : this.spouseFormValidation.weddingCountry = false;
      (Utils.isEmptyNullOrUndefined(this.spouseForm.weddingState) && this.spouseForm.weddingCountry === 'BRASIL') ? this.spouseFormValidation.weddingState = true : this.spouseFormValidation.weddingState = false;
      Utils.isEmptyNullOrUndefined(this.spouseForm.weddingCity) ? this.spouseFormValidation.weddingCity = true : this.spouseFormValidation.weddingCity = false;
      if(!this.spouseFormValidation.erros && this.spouseForm.selectedSpousePerson && this.isNotTheSamePerson(this.spouseForm.selectedSpousePerson)){
        const spouse =  {... await ClientBusiness.getById(this.spouseForm.selectedSpousePerson.id)};
        if ((this.isAlreadyMarried(this.clientForm.spouses, this.spouseForm) || this.isAlreadyMarried(spouse.spouses, this.spouseForm)) && this.spouseForm.current) {
            const marriedPersonName = this.isAlreadyMarried(this.clientForm.spouses, this.clientForm) ? this.clientForm.name : spouse.name;
            ToastMessageBusiness.showError(this.$t('forms.client.wedding-current-error', { name: marriedPersonName}));
        } else {
          let addWeddingWithNoDate = true
          if (Utils.isEmptyNullOrUndefined(this.spouseForm.date) 
          || Utils.isEmptyNullOrUndefined(this.spouseForm.weddingCountry) 
          || (Utils.isEmptyNullOrUndefined(this.spouseForm.weddingState) && this.spouseForm.weddingCountry !== 'BRASIL')
          || Utils.isEmptyNullOrUndefined(this.spouseForm.weddingCity)) {
            addWeddingWithNoDate = await DialogService.openConfirmationModal(AncestrylineConfirmation, {message: "forms.client.wedding-information"});
          }
          if (addWeddingWithNoDate) {
            DialogService.closeModal(this.spouseForm);
          }
        }
      }
    },

    isNotTheSamePerson(spouse){
      return spouse.id !== this.clientForm.id;
    },

    async modalClientSpouseForm(field){
      const client = await DialogService.openModal(ModalClientForm, {}, 1000);
      if(client){
        this.$set(this.spouseForm, field, client);
      }
    },

    forceUpdateFieldSpouseForm(field, value){
      this.$set(this.spouseForm, field, value);
    },

    isAlreadyMarried(spouses, spouseForm) {
      if (!spouses) {
        spouses = [];
      }
      return spouses.filter(marries => marries.current && (!spouseForm.id || spouseForm.id !== marries.id)).length > 0;
    },

    created() {
      if(store.getLayoutColor() === this.dark){
        this.content_css = 'dark';
        this.skin = 'oxide-dark';
      }
    },

  },

}
</script>

<style scoped>

</style>